import { useState, useEffect } from 'react';
import { TestMailboxSend } from '../../../../actions/MailboxActions';


const MailboxSendTest = (props) => {
    const [emailAddress, setEmailAddress] = useState('');
    const [display, setDisplay] = useState('input');
    const [errorMsg, setErrorMsg] = useState('');

    const sendEmail = () => {
        console.log(props.mailboxId);
        console.log(emailAddress);
        TestMailboxSend(props.mailboxId, emailAddress, showSendResult);
        setDisplay('sending');
    }

    const showSendResult = (result) => {
        console.log(result);
        if(result.result === 'Success') {
            setDisplay('done');
        }
        if(result.result === 'Error') {
            setDisplay('error');
            setErrorMsg(result.message);
        }
    }



    return (
        <div className='td-dialogue-container'>
            <div
              className='td-dialogue card'
              style={{ height: '230px', width: '300px' }}
            >
              <div className='card-header'>
                Send Notification Test
                <button onClick={() => props.close()} className='btn-close' />
              </div>
              <div className='card-body'>
                {display === 'input' &&
                    <>
                    <div className='form-group mt-2'>
                      <label>Send To:</label>
                      <input className='form-control' value={emailAddress} onChange={(e) => setEmailAddress(e.target.value)}></input>
                    </div>
                    <button
                        onClick={sendEmail}
                        className='btn btn-success mt-3 w-100'
                        disabled={emailAddress.length === 0 ? true : false}
                        >
                        Send
                    </button>
                    </>

                }
                {display === 'sending' &&
                    <div style={{width: '270px', textAlign: 'center'}}>
                        <div className='mt-4' style={{color: '#56b21e'}}>
                            <i className='fa-solid fa-spinner fa-spin fa-3x'></i>
                        </div>
                        <div className mt-3>Sending...</div>
                    </div>
                }
                {display === 'done' &&
                    <div style={{ color: '#3D9E31' }}>
                        <h4>Email sent</h4>
                    </div>
                }
                 {display === 'error' &&
                    <div style={{ color: '#DE2C38' }}>
                        <h3>Error</h3>
                        <p>{errorMsg}</p>
                    </div>
                }
              </div>
            </div>
        </div>

    )
}

export default MailboxSendTest;